import isEmpty from 'lodash/isEmpty';

const getState = state => state.account.paymentrequest.request;

export const isRequesting = state => getState(state).requesting;
export const getError = state => getState(state).error;
export const isError = state => !isEmpty(getError(state));
export const isSuccess = state => getState(state).success;



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/request/selector.js